module.exports = __webpack_public_path__ + "static/media/g.5a60cf33.svg";